// events
// interface JsonRpcEvent {
//     method: string;
//     params?: object;
// }
//
// interface JsonRpcRequest extends JsonRpcEvent {
//     id: number | string;
// }
//
// interface JsonRpcError {
//     data?: object;
//     message?: string;
// }
//
// interface JsonRpcResponseError {
//     id: number | string;
//     error: JsonRpcError;
// }
//
// interface JsonRpcResponseResult {
//     id: number | string;
//     result?: object;
// }
//
// type JsonRpcResponse = JsonRpcResponseError | JsonRpcResponseResult;

import isString from 'lodash-es/isString';
import MessageTracker from '@adt/message-tracker';

function filter(solver) {
  if (solver.message.id === solver.current.id) {
    if (solver.message.error) {
      solver.reject(solver.message);
    } else {
      solver.resolve(solver.message);
    }
  }
}

export function create(frame) {
  const manager = new MessageTracker({ timeout: 1 });

  frame.postMessage = function (message) {
    // https://bitbucket.unifiedfactory.com/projects/SAAS/repos/widgetloader/pull-requests/287/diff
    if (this.contentWindow) {
      this.contentWindow.postMessage(message, '*');
    }
  };

  // todo second message event listener is in loader.js
  window.addEventListener('message', event => {
    manager.matchMessage(event.data);
  }, false);

  // function postRequest(request: JsonRpcRequest): Promise<JsonRpcResponse> {
  function postRequest(request) {
    const result = manager.register({
      message: request,
      filter,
      timeoutRejectWith: {
        id: request.id, error: {
          data: request,
          message: 'timeout exceeded',
        }
      }
    });

    frame.postMessage(request);

    return result;
  }

  // function sendRequest(method, params): Promise < JsonRpcResponse >
  function sendRequest(method, params) {
    // const request: JsonRpcRequest = {id: Date.now(), method};
    const request = { id: Date.now(), method };
    if (params) request.params = params;
    return postRequest(request);
  }

  // function sendResponseResult(id: number | string, result
  function sendResponseResult(id, result) {
    const response = { id };
    if (result) response.result = result;
    frame.postMessage(response);
  }

  function sendRpcEvent(method, params) {
    const message = { method };
    if (params) message.params = params;
    frame.postMessage(message);
  }

  // mode - 'audio' | 'video'
  function goToChat(mode) {
    sendRpcEvent('GoToChat', { calling: mode });
  }

  function goToMail() {
    sendRpcEvent('GoToMail');
  }

  const setUsername = (username) => {
    sendRpcEvent('SetUsername', { username });
    // return sendRequest('SetUsername', {username});
  };

  const setEmail = (email) => {
    sendRpcEvent('SetEmail', { email });
    // return sendRequest('SetEmail', {email});
  };

  const addTags = (...tags) => {
    sendRpcEvent('AddTags', { tags });
    // return sendRequest('AddTags', {tags});
  };

  const removeTags = (...tags) => {
    sendRpcEvent('RemoveTags', { tags });
    // return sendRequest('RemoveTags', {tags});
  };

  const setColor = (color) => {
    sendRpcEvent('SetColor', { color });
    // return sendRequest('SetColor', {color});
  };

  const sendApiMessage = (key, value) => {
    sendRpcEvent('ApiMessage', { key, value });
  };

  const sendApiRequest = (key, value) => {
    return sendRequest('ApiRequest', { key, value });
  };

  // const setOffsetX =  (offsetX: number) => {
  const setOffsetX = (offsetX) => {
    sendRpcEvent('SetOffsetX', { offsetX });
    // return sendRequest('SetOffsetX', {offsetX});
  };

  // const setOffsetY =  (offsetY: number) => {
  const setOffsetY = (offsetY) => {
    sendRpcEvent('SetOffsetY', { offsetY });
    // return sendRequest('SetOffsetY', {offsetY});
  };

  // const setPosition =  (position: string) => {
  const setPosition = (position) => {
    return sendRequest('SetPosition', { position });
  };

  // const setCustomData =  (customData: string) => {
  const setCustomData = (customData) => {
    customData = isString(customData) ? customData : JSON.stringify(customData);
    return sendRequest('SetCustomData', { customData });
  };

  // use async/await
  const sendMessage = (message, customData) => {
    const params = { message };
    if (customData) params.customData = customData;
    return sendRequest('SendMessage', params);
  };

  const getStoredAttribute = (key) => {
    const params = { key };

    return sendRequest('GetStoredAttribute', params);
  };

  const api = {
    goToChat, goToMail, getStoredAttribute,
    sendResponseResult, sendRpcEvent, // todo remove
    setUsername, setEmail, addTags, removeTags,
    sendApiMessage, sendApiRequest, setColor, setOffsetX, setOffsetY, setPosition,
    setCustomData, sendMessage
  };

  return api;
}
